module.exports = __webpack_public_path__ + "static/media/guests_distribution.fbb1b8e5.svg";